import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const reviewStarFn = /* @__PURE__ */ createRecipe('reviewStar', {}, [])

const reviewStarVariantMap = {
  "filled": [
    "true",
    "false"
  ]
}

const reviewStarVariantKeys = Object.keys(reviewStarVariantMap)

export const reviewStar = /* @__PURE__ */ Object.assign(memo(reviewStarFn.recipeFn), {
  __recipe__: true,
  __name__: 'reviewStar',
  __getCompoundVariantCss__: reviewStarFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: reviewStarVariantKeys,
  variantMap: reviewStarVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, reviewStarVariantKeys)
  },
  getVariantProps: reviewStarFn.getVariantProps,
})